export default __webpack_public_path__ + "static/media/bg-img.5b7f1ecc.jpg";